import React from 'react';

import HighlightedQuestion from './HighlightedQuestion';
import StatisticsQuestionSelect from './StatisticsQuestionSelect';

class StatisticsCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      highlight: props.highlighted || Object.keys(props.questions)[0],
      panelOpen: false,
      data: props.questions ? this.formatData(props.questions) : {}
    };

    this.handlePanelClick = this.handlePanelClick.bind(this);
    this.handleQuestionClick = this.handleQuestionClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.questions !== this.props.questions) {
      this.setState({
        data: this.formatData(nextProps.questions)
      });
    }
  }

  formatData(data) {
    const formattedData = this.sortByKey(data);
    return this.joinTextQuestions(formattedData);
  }

  joinTextQuestions(data) {
    const joinedData = {};

    let lastFound;
    Object.keys(data).forEach(key => {
      const question = data[key];

      if (question.input_type === 'text') {
        if (lastFound) {
          joinedData[lastFound].questions.push(question);
          lastFound = null;
        } else {
          question.questions = [question];
          joinedData[key] = question;
          lastFound = key;
        }
      } else {
        joinedData[key] = question;
        lastFound = null;
      }
    });

    return joinedData;
  }

  sortByKey(data) {
    const sortedData = {};
    const sortedKeys = Object.keys(data).sort((keyA, keyB) => {
      if (keyA < keyB) {
        return -1;
      } else if (keyA > keyB) {
        return 1;
      }
      return 0;
    });

    sortedKeys.forEach(key => {
      sortedData[key] = data[key];
    });

    return sortedData;
  }

  getHighlighted() {
    const highlight = this.state.highlight,
      data = this.state.data;

    return data[highlight];
  }

  setHighlighted(id) {
    this.setState({
      highlight : id
    });
  }

  collapsePanel() {
    this.setState({
      panelOpen: false
    })
  }

  handleQuestionClick(id) {
    this.setHighlighted(id);
    this.collapsePanel();
  }

  handlePanelClick(event) {
    this.setState({ panelOpen: !this.state.panelOpen });
  }

  panelHeader() {
    return (
      <div>
        { this.state.panelOpen
          ? <div className="question-stack-prompt">
              <span>Select an item </span>
              <button
                onClick={ this.handlePanelClick }
                className="btn btn-default btn-xs"
              >
                close
              </button>
            </div>
          : <h4 onClick={ this.handlePanelClick }>More from this topic </h4>
        }
      </div>
    );
  }

  render() {
    const title = this.props.title,
      data = this.state.data;

    return (
      <div className="statistics-card" id={this.props.sectionId}>
        <div className="title">
          <h3> {title} </h3>
        </div>

        <div className="card-body">
          <HighlightedQuestion question={ this.getHighlighted() } />

          <StatisticsQuestionSelect
            open={ this.state.panelOpen }
            header={ this.panelHeader() }
            questions={ data }
            highlighted={ this.state.highlight }
            onQuestionClick={ this.handleQuestionClick }
          />
        </div>
      </div>
    );
  }
}

export default StatisticsCard;



// WEBPACK FOOTER //
// ./src/components/Statistics/StatisticsCard.js